
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_486_219)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.627 2.756A9 9 0 002.251 16.953a1 1 0 001.498-1.326A7 7 0 1115.772 9.25a1 1 0 00.968.751h1.261a4 4 0 012.304 7.272 1 1 0 101.15 1.636A6 6 0 0018 8h-.518a9 9 0 00-4.854-5.244zM12 11a1 1 0 011 1v6.586l2.293-2.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L11 18.586V12a1 1 0 011-1z","fill":"#04080E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_486_219"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    